<div class="around">
    <i class="fal fa-times close-btn" title="Đóng" (click)="close()"></i>
    <label for="" class="layer-label">Data Search</label>

    <form action="#" class="search-form" *ngIf="createForm" [formGroup]="createForm">
        <div class="form-group">
            <label for="">Select data</label>
            <select class="form-select" formControlName="TableName">
                <option *ngFor="let table of tables" value="{{ table.value }}">
                    {{ table.text }}
                </option>
            </select>
        </div>
        <div class="form-group" *ngIf="createForm.controls.TableName.value == 'watershed'">
            <label for="">By attribute</label>
            <select class="form-select" formControlName="fieldName">
                <option *ngFor="let attr of waterShedAttrs" value="{{ attr.value }}">
                    {{ attr.text }}
                </option>
            </select>
            <div class="form-group">
                <div class="row">
                    <div class="col-6">
                        <select class="form-select" formControlName="condition">
                            <option *ngFor="let condition of conditions" value="{{ condition.value }}">
                                {{ condition.text }}
                            </option>
                        </select>
                    </div>
                    <div class="col-6">
                        <div class="input-group">
                            <input type="text" class="form-control border-right-0" formControlName="value">
                            <span class="input-group-text">
                {{ createForm.controls.fieldName.value == 'runoff' ? 'm³' : 'Km²' }}
              </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group" *ngIf="createForm.controls.TableName.value == 'floodprone'">
            <label for="">By attribute</label>
            <select class="form-select" formControlName="fieldName">
                <option *ngFor="let attr of floodProneAttrs" value="{{ attr.value }}">
                    {{ attr.text }}
                </option>
            </select>
            <div class="form-group">
                <div class="row">
                    <div class="col-6">
                        <select class="form-select" formControlName="condition">
                            <option *ngFor="let condition of conditions" value="{{ condition.value }}">
                                {{ condition.text }}
                            </option>
                        </select>
                    </div>
                    <div class="col-6">
                        <div class="input-group">
                            <input type="text" class="form-control border-right-0" formControlName="value">
                            <span class="input-group-text">Km²</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group" *ngIf="createForm.controls.TableName.value == 'subbasin'">
            <label for="">By attribute</label>
            <select class="form-select" formControlName="fieldName">
                <option *ngFor="let attr of subBasinAttrs" value="{{ attr.value }}">
                    {{ attr.text }}
                </option>
            </select>

            <select class="form-select mt-2" formControlName="value"
                    *ngIf="createForm.controls.fieldName.value == subBasinAttrs[0].value">
                <option *ngFor="let field of subBasinFieldValues" value="{{ field.value }}">
                    {{ field.text }}
                </option>
            </select>

            <div class="form-group" *ngIf="createForm.controls.fieldName.value != subBasinAttrs[0].value">
                <div class="row">
                    <div class="col-6">
                        <select class="form-select" formControlName="condition">
                            <option *ngFor="let condition of conditions" value="{{ condition.value }}">
                                {{ condition.text }}
                            </option>
                        </select>
                    </div>
                    <div class="col-6">
                        <div class="input-group">
                            <input type="text" class="form-control border-right-0" formControlName="value">
                            <span class="input-group-text">
                {{ createForm.controls.fieldName.value == 'area' ? 'Km²' : 'm³' }}
              </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="form-group text-center">
            <button class="btn btn-success btn-search" (click)="onSubmit()">
                Search
            </button>
        </div>
    </form>
</div>
<div class="data-items">
    <div class="around" *ngIf="dataItems && dataItems.tableName">
        <i class="fal fa-times close-btn" title="Đóng" (click)="closeItems()"></i>
        <label for="" class="layer-label">
            All {{ dataItems.tableName }}
        </label>
        <ngx-simplebar [ngStyle]="{ height: 'calc(38vh)' }">
            <div class="wraptable" *ngIf="dataItems.tableName == 'watershed'">
                <table class="table table-bordered">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">GID</th>
                        <th scope="col">Region</th>
                        <th scope="col">Watershed type</th>
                        <th scope="col">Watershed of the river</th>
                        <th scope="col">Area (Km²)</th>
                        <th scope="col">Runoff capacity (m³)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of dataItems.items">
                        <th scope="row">{{ item.gid }}</th>
                        <td>{{ item.region }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.riverName }}</td>
                        <td>{{ item.area | number }}</td>
                        <td>{{ item.runoff | number }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="wraptable" *ngIf="dataItems.tableName == 'floodprone'">
                <table class="table table-bordered">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">GID</th>
                        <th scope="col">Area (Km²)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of dataItems.items">
                        <th scope="row">{{ item.gid }}</th>
                        <td>{{ item.area | number }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="wraptable" *ngIf="dataItems.tableName == 'subbasin'">
                <table class="table table-bordered">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">Sub-basin</th>
                        <th scope="col">Area (sq. km.)</th>
                        <th scope="col">Total flow into the subbasin (m³)</th>
                        <th scope="col">Runoff generated (m³)</th>
                        <th scope="col">100% drain capacity running through DTP drain (m³)</th>
                        <th scope="col">100% drain capacity running through Rajabheta drain (m³)</th>
                        <!--                        <th scope="col">80% drain capacity running through DTP drain (m³)</th>-->
                        <!--                        <th scope="col">80% drain capacity running through Rajabheta drain (m³)</th>-->
                        <th scope="col">Drain capacity running through the subbasin (m³)</th>
                        <!--                        <th scope="col">Existing drain cleaning</th>-->
                        <!--                        <th scope="col">Existing pumping stations</th>-->
                        <!--                        <th scope="col">Potential contructed wetlands</th>-->
                        <!--                        <th scope="col">Potential natural drainage path restoration</th>-->
                        <!--                        <th scope="col">Potential sponge gardens and pocket parks</th>-->
                        <!--                        <th scope="col">Potential retention ponds and rain gardens</th>-->
                        <!--                        <th scope="col">Potential drainage corridor enhancement</th>-->
                        <!--                        <th scope="col">Potential stormwater infiltration</th>-->
                        <!--                        <th scope="col">Potential pervious paving</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of dataItems.items">
                        <td style="width: 100px;">{{ item.subBasin }}</td>
                        <td>{{ item.area | number }}</td>
                        <td>{{ item.totalFlow | number }}</td>
                        <td>{{ item.runoff | number }}</td>
                        <td>{{ item.dtpCap100 | number }}</td>
                        <td>{{ item.rajaCap100 | number }}</td>
                        <!--                        <td>{{ item.dtpCap80 | number }}</td>-->
                        <!--                        <td>{{ item.rajaCap80 | number }}</td>-->
                        <td>{{ item.drainCap | number }}</td>
                        <!--                        <td>{{ item.edrain }}</td>-->
                        <!--                        <td>{{ item.epump }}</td>-->
                        <!--                        <td>{{ item.pwetland }}</td>-->
                        <!--                        <td>{{ item.pdrainage }}</td>-->
                        <!--                        <td>{{ item.ppark }}</td>-->
                        <!--                        <td>{{ item.pgarden }}</td>-->
                        <!--                        <td>{{ item.penhance }}</td>-->
                        <!--                        <td>{{ item.pstormwt }}</td>-->
                        <!--                        <td>{{ item.ppaving }}</td>-->
                    </tr>
                    </tbody>
                </table>
            </div>
        </ngx-simplebar>
    </div>
</div>
